import React from 'react';
import styled from 'styled-components';
// components
import PortalContainer from '../portal/portalContainer';

const Toolbar = ({ className }) => (
  <div className={className}>
    <PortalContainer />
  </div>
);

export default styled(Toolbar)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: white;
  height: 60px;
  border-bottom: 1px solid var(--grey200);
`;
